import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=e8b41f2a&scoped=true&"
import script from "./EmailTemplate.vue?vue&type=script&lang=js&"
export * from "./EmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&id=e8b41f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b41f2a",
  null
  
)

export default component.exports